import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { ITyped } from '../../shared/interfaces/typed.interface';
import { DashboardComponentTypesEnum } from '../reports.enum';

export const SUMMARY_SCHEMA = Object.freeze({
  TYPE: '',
  TOTAL: 0,
  LABEL: null, // string
  SUB_LABEL: null, // string
  GROUP: 0,
  URL: null, // string
});
const RECORD = generateSchema(SUMMARY_SCHEMA);
const KEYS: any = generateKeys(SUMMARY_SCHEMA);

export class Summary extends Record(RECORD) implements ITyped {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get type(): string {
    return DashboardComponentTypesEnum.summary;
  }

  get total(): number {
    return this.get(KEYS.TOTAL);
  }

  get label(): string {
    return this.get(KEYS.LABEL);
  }

  get subLabel(): string {
    return this.get(KEYS.SUB_LABEL);
  }

  get group(): number {
    return this.get(KEYS.GROUP);
  }

  get url(): string {
    return this.get(KEYS.URL);
  }
}
